import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report-admin',
  templateUrl: './report-admin.component.html',
  styleUrls: ['./report-admin.component.css'],
})
export class ReportAdminComponent implements OnInit {
ReportURL0 =  'CocReports/DoctorsList';
ReportURL1 =  'CocReports/SuppList';
ReportURL2 =  'CocReports/ItemsList';
ReportURL3 =  'CocReports/RoomsList';
ReportURL4 =  'CocReports/Protocols';

constructor(public route: Router){

}
  ngOnInit(): void {}

  ReportDoctor(){
    this.route.navigate(['report-vewier', this.ReportURL0]); 
  }
  ReportSuppliers(){
    this.route.navigate(['report-vewier', this.ReportURL1]);
  }
  ReportItems(){
    this.route.navigate(['report-vewier', this.ReportURL2]);
  }
  ReportRooms(){
    this.route.navigate(['report-vewier', this.ReportURL3]);
  }
  ReportProtocols(){
    this.route.navigate(['report-vewier', this.ReportURL4]);
  }
}
